import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/hooks/use-language";
import { getTranslation } from "@/lib/translations";

export default function HeroSection() {
  const { language } = useLanguage();
  
  return (
    <div className="relative overflow-hidden">
      {/* Background Image - Poznan City */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center"
        style={{ 
          backgroundImage: "url('https://storage.googleapis.com/fenado-ai-farm-public/generated/57d2cd5f-82e8-474c-ac2a-26d96b812d7d.webp')",
        }}
      >
        {/* Overlay to make text readable */}
        <div className="absolute inset-0 bg-gradient-to-b from-background/95 via-background/90 to-background/80"></div>
      </div>
      
      {/* Background pattern */}
      <div className="absolute inset-0 z-0 opacity-5 grid-pattern"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-20 right-[10%] w-64 h-64 rounded-full bg-primary opacity-10 blur-3xl float-animation-slow"></div>
      <div className="absolute bottom-20 left-[5%] w-80 h-80 rounded-full bg-primary opacity-10 blur-3xl float-animation"></div>
      
      {/* Content */}
      <div className="container relative z-10 py-16 md:py-24 lg:py-32 flex items-center justify-center text-responsive-spacing">
        <div className="text-center max-w-2xl animate-fade-in-up content-padding">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold mb-4 md:mb-6 leading-tight px-2 md:px-0">
            {language === 'pl' ? (
              <>Kompleksowe usługi dla biznesu i życia codziennego</>
            ) : (
              getTranslation('heroTitle', language)
            )}
          </h1>
          <p className="text-lg sm:text-xl text-foreground/80 mb-6 md:mb-8 mx-auto px-2 sm:px-4 md:px-6">
            {language === 'pl' ? "Od rejestracji spółek, przez obsługę prawną i księgowość, po legalizację pobytu i rejestrację pojazdów." : getTranslation('heroDescription', language)}
          </p>
          
          <div className="flex justify-center px-4">
            <Link to="/kompleksni-poslugy">
              <Button 
                size="lg" 
                className="button-modern button-responsive"
              >
                {language === 'pl' ? "Zobacz Nasze Usługi" : getTranslation('heroContactButton', language)}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
      
      {/* Wave divider */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className="w-full h-[60px] text-background">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>
  );
}